import client from "../client";
import { apiList } from "../apiList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // returns list of all the people
  createDeposit: (payload) => client.post(apiList.depositTransaction, { json: payload }).json(),
  createWithdrawal: (payload) => client.post(apiList.withdrawalTransaction, { json: payload }).json(),
  getPaymentAccountList : (id) => client.get(`${apiList.paymentAccount}/${id}`)
};

// {userId: userId, startDate: startDate, endDate: endDate}